module.exports = __webpack_public_path__ + "static/img/press7.3f438bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/press7.png
// module id = YO4J
// module chunks = 0